import React from 'react';
import {Outlet} from 'react-router-dom';

const Assignments: React.FC = () => {
  return <Outlet />;
};

export default Assignments;
